import { useTranslation } from 'react-i18next';
import { useTenant } from '../../../providers/tenant';
import { useAzureMsal } from '../../../providers/azure';
import {
    Link,
    Typography,
    CardActionArea,
    useTheme,
    IdpProvider,
} from '@bluedolphin/ui';

/**
 * Identity Providers List component
 *
 * @returns {JSX.Element}
 */
export default function IDPList(): JSX.Element {
    const theme = useTheme();
    const { tenantMeta: tenant } = useTenant();
    const { login } = useAzureMsal();
    const { t } = useTranslation();

    return (
        <>
            <div className="idp__list__wrapper">
                {tenant &&
                    tenant?.b2CPolicies &&
                    tenant?.b2CPolicies.map((policy) => (
                        <CardActionArea key={policy.id}>
                            <IdpProvider
                                policy={policy}
                                loginUser={() => login(policy)}
                            ></IdpProvider>
                        </CardActionArea>
                    ))}
            </div>
            <div className="idp__list__links">
                <Link
                    href={t('links.forgotPasswordURL')}
                    target="_blank"
                    underline="hover"
                >
                    <Typography
                        variant="body2"
                        sx={{
                            color: theme.palette.primary.main,
                            display: 'inline',
                        }}
                    >
                        {t('links.forgotPassword')}
                    </Typography>
                </Link>
                <Link
                    href="mailto:support@valueblue.nl"
                    target="_blank"
                    underline="hover"
                >
                    <Typography
                        variant="body2"
                        sx={{
                            color: theme.palette.primary.main,
                            display: 'inline',
                        }}
                    >
                        {t('links.needLoginHelp')}
                    </Typography>
                </Link>
            </div>
        </>
    );
}
